import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArchive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"archive, folder, box"} maskId="square-filled-radius-0-stroke-1-IconArchive"><path fillRule="evenodd" clipRule="evenodd" d="M5.5 2V8H3V21H21V8H18.5V4H12.7071L10.7071 2H5.5ZM17.5 8V5H12.2929L10.2929 3H6.5V8H17.5ZM7 12H12V13H7V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArchive;
